import validate from "/home/u293765147/domains/comandaplus.com/hbuilds/source/node_modules/nuxt/dist/pages/runtime/validate.js";
import domain_45global from "/home/u293765147/domains/comandaplus.com/hbuilds/source/middleware/domain.global.ts";
import manifest_45route_45rule from "/home/u293765147/domains/comandaplus.com/hbuilds/source/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  domain_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/u293765147/domains/comandaplus.com/hbuilds/source/middleware/auth.ts")
}